
const StepsEnum = {
    START_TROUBLESHOOTING_WIZARD_LOADER: 'START_TROUBLESHOOTING_WIZARD_LOADER',

    //BROWSING
    SUCCESS_SWITCH_MONITOR: 'SUCCESS_SWITCH_MONITOR',
    UPDATED_SETTINGS: 'UPDATED_SETTINGS',

    //CALLS
    SELECT_CALLS_TYPE: 'SELECT_CALLS_TYPE',
    CHECK_INCOMING_CALLS: 'CHECK_INCOMING_CALLS',
    CHECK_OUTGOING_CALLS: 'CHECK_OUTGOING_CALLS',

    //MABAL
    HAS_BLOCK_OUTGOING_CALLS_MABAL: 'HAS_BLOCK_OUTGOING_CALLS_MABAL',
    OPEN_OUTGOING_CALLS_MABAL: 'OPEN_OUTGOING_CALLS_MABAL',
    OPEN_OUTGOING_CALLS_MABAL_SUCCESS: 'OPEN_OUTGOING_CALLS_MABAL_SUCCESS',

    UPDATING_SETTINGS: 'UPDATING_SETTINGS',

    SHOW_EXTENDED_OTP_POPUP: 'SHOW_EXTENDED_OTP_POPUP'

  };

  export default StepsEnum;
